// The certificate and the Letter of Good Standing both print the member's ACA
// membership number, allocated by the database when the member is certified.
//
// A row read back before the trigger has run (or an older uncertified record)
// has none yet, so fall back to the short application id rather than leaving the
// slot on the certificate blank.
export const memberNumberOf = (app: { membership_number?: number | null; id: string }): string =>
  app.membership_number != null ? String(app.membership_number) : app.id.slice(0, 8);
